import type { TOC } from '@ember/component/template-only'

export const ReportingControlsGap: TOC<unknown> = <template>
  <div class="border-dusty-black-100 my-0 self-stretch border-r"></div>
</template>

export default ReportingControlsGap
